<div class="directCallMembers panel" [class.stickyMode]="stickyMode" [class.withMenu]="withMenu">
  @if (!stickyMode) {
    <div class="close" (click)="closeChat()">
      <label class="close-icon">
        <i class="material-icons notranslate">close</i>
      </label>
    </div>
  }
  @if (this.userDataService.assetInfo) {
    <div class="allparticipants">
      @if (!stickyMode || !isExpert) {
        <h3 class="participants-title">{{'PARTICIPANTS' | translate}}</h3>
      }
      @if (isExpert) {
        <app-invitations></app-invitations>
      }
      @for (participant of this.userDataService.assetInfo.participants; track participant) {
        <div class="participant">
          <div class="visible-info">
            <div class="icon" id="participantIcon"> <img [src]="participant.role | roleBackground" /></div>
            @if (participant.name) {
              <div class="name">
                <p>{{participant.name}}</p>
              </div>
            }
            @if (!participant.name) {
              <div class="name">
                <p>{{'GUEST' | translate}}</p>
              </div>
            }
            <!--<div *ngIf="versionShow" class="mute" (click)="switchMute(participant)">
            <img *ngIf="!participant.mute" src="/assets/images/buttons/voice-on.svg" />
            <img *ngIf="participant.mute" src="/assets/images/buttons/voice-off.svg" />
          </div>-->
          <div>
            @if (isExpert && participant.role == UserRole.TechnicianGlass) {
              <div class="call-glass" matTooltip="{{callAppTooltip}}">
                <img src="/assets/images/buttons/glass.svg" class="call-button hvr-grow" (click)="callDevice(participant)" />
              </div>
            }
            @if (isExpert && participant.role == UserRole.TechnicianMobile) {
              <div class="call-mobile" matTooltip="{{callAppTooltip}}">
                <img src="/assets/images/buttons/mobile.svg" class="call-button hvr-grow" (click)="callDevice(participant)" />
              </div>
            }
          </div>
          <div class="call">
            @if ((isExpert && participant.role != this.userDataService.Role) || (!isExpert && participant.role == UserRole.Expert)) {
              <div class="button" [ngClass]="{'online' : ((this.userDataService.assetInfo.transcriptionsOn && this.userDataService.assetInfo.transcriptionsLanguage != undefined) || !this.userDataService.assetInfo.transcriptionsOn) || participant.callId == null, 'offline' : (this.userDataService.assetInfo.transcriptionsOn && this.userDataService.assetInfo.transcriptionsLanguage == undefined)  || participant.callId != null || inCall}" (click)="makeCall(participant)">
                <i class="fa fa-phone"></i>
              </div>
            }
          </div>
          <div>
            @if (isExpert) {
              <div class="translations" [class.active]="translateChatOn" [class.selected-lang]="participant.translationLanguage != undefined" matTooltip="{{'TOOLTIP.SELECT_LANGUAGE' | translate}}" [matTooltipShowDelay]="1500">
                <img src="/assets/images/buttons/translation.svg" (click)="toggleTranslations(participant)" />
                <!--<img *ngIf="!participant.isInAsset" src="/assets/images/buttons/translation-bn.svg" />-->
              </div>
            }
          </div>
        </div>
        @if (isExpert) {
          <div class="translations-info" [ngClass]="{ 'translations-open': participant.translationsOpen, 'inCall': inCall }">
            @if (inCall) {
              <div class="origin-language-container">
                <mat-label for="originLang" class="translate-label">{{'LANGUAGE_ORIGIN' | translate}}</mat-label>
                <div class="origin-language">
                  <mat-form-field class="translate-select">
                    <mat-select id="originLang" [(value)]="participant.originLanguage" placeholder="{{'LANGUAGE' | translate}}" [disabled]="participant.translateVoiceOn != undefined && participant.translateVoiceOn && participant.originLanguage != undefined && participant.translationLanguage != undefined" (selectionChange)="updateTranslationLang(participant, true)">
                      <mat-option [value]="undefined"> ----- </mat-option>
                      @for (lang of langsFrom; track lang) {
                        <mat-option [value]="lang[0]">{{lang[1]}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }
            <div class="translated-language-container">
              <mat-label for="translatedLang" class="translate-label">{{'LANGUAGE_TO_TRANSLATE' | translate}}</mat-label>
              <div class="translated-language">
                <mat-form-field class="translate-select">
                  <mat-select id="translatedLang" [(value)]="participant.translationLanguage" placeholder="{{'LANGUAGE' | translate}}" [disabled]="participant.translateVoiceOn != undefined && participant.translateVoiceOn && participant.originLanguage != undefined && participant.translationLanguage != undefined" (selectionChange)="updateTranslationLang(participant, false)">
                    <mat-option [value]="undefined"> ----- </mat-option>
                    @for (lang of langs; track lang) {
                      <mat-option [value]="lang[0]">{{lang[1]}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            @if (inCall) {
              <div class="translate-button-container" id="toggle_publisher_video_type_div" matTooltip="{{ !this.userDataService.assetInfo.translationEnabled ? ('TOOLTIP.TRANSLATION_DISABLED' | translate) : '' }}" [matTooltipShowDelay]="1500">
                <div class="translate-button">
                  @if (participant.translateVoiceOn && isExpert) {
                    <button (click)="translationVoiceEnabled ? translateVoice(participant) : null" class="btn btn-default sidebar">
                      <img src="/assets/images/translations/translation-stop.svg" class="call-button hvr-grow blink" style="padding: 3px 0">
                    </button>
                  }
                  @if (!participant.translateVoiceOn && isExpert) {
                    <button class="btn btn-default sidebar" [disabled]="!participant.microphone || !translationVoiceEnabled || participant.originLanguage == undefined || participant.translationLanguage == undefined" (click)="translationVoiceEnabled && (participant.originLanguage != undefined && participant.translationLanguage != undefined) ? translateVoice(participant) : null">
                      <img src="/assets/images/translations/translation-start.svg" class="call-button hvr-grow" style="padding: 3px 0">
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

<div class="buttons" [class.inCall]="inCall">
  <!-- SUBTITLES -->
  @if (isExpert && inCall) {
    <div class="subtitles-on check" [class.selected]="translateSubtitlesOn" [class.disabled-checkbox]="!translateSubtitleEnabled" matTooltip="{{'TOOLTIP.SUBTITLE' | translate}}" [matTooltipShowDelay]="1500">
      <img [src]="translateSubtitlesOn ? '/assets/images/translations/translation-subtitle.svg' : '/assets/images/translations/translation-subtitle-off.svg'" />
      <p>{{'TRANSLATION.SUBTITLES' | translate}}</p>
      <mat-slide-toggle color="primary" hideIcon="true" (toggleChange)="audioConnectorService.translateSubtitles()" [disabled]="!translateSubtitleEnabled" [checked]="translateSubtitlesOn" class="material-icons"></mat-slide-toggle>
    </div>
  }

  <!--CHAT-->
  @if (isExpert) {
    <div class="translate-chat-on check" [class.selected]="translateChatOn" matTooltip="{{'TOOLTIP.TRANSLATE_CHAT' | translate}}" [matTooltipShowDelay]="1500"><!-- [class.disabled-checkbox]="!chatEnabled"-->
      <img [src]="translateChatOn ? '/assets/images/translations/translation.svg' : '/assets/images/translations/translation-off.svg'" />
      <p style="color:white">{{'TRANSLATION.CHAT' | translate}}</p>
      <mat-slide-toggle color="primary" hideIcon="true" (toggleChange)="translateChat()" [checked]="translateChatOn" class="material-icons"></mat-slide-toggle> <!-- [disabled]="!chatEnabled"-->
    </div>
  }

  <!--TRANSCRIPTIONS-->
  @if (isExpert) {
    <div class="transcriptions-on check" [class.selected]="transcriptionsOn" [class.disabled-checkbox]="!transcriptionsEnabled" matTooltip="{{'TOOLTIP.TRANSCRIPT_CALL' | translate}}" [matTooltipShowDelay]="1500">
      <img [src]="transcriptionsOn ? '/assets/images/translations/translation.svg' : '/assets/images/translations/translation-off.svg'" />
      <p style="color:white">{{'TRANSCRIPTIONS' | translate}}</p>
      <mat-slide-toggle color="primary" hideIcon="true" (change)="this.toggleTranscriptions($event)" [disabled]="!transcriptionsEnabled" [checked]="transcriptionsOn" class="material-icons"></mat-slide-toggle>
      <div class="transcriptions-info" [ngClass]="{ 'transcription-open': transcriptionsOn }">
        <div class="origin-language">
          <mat-form-field class="translate-select">
            <mat-select #transcriptLangSelect [(value)]="transcriptionLanguage" placeholder="{{'CONVERSATION_LANGUAGE' | translate}}" [disabled]="!transcriptionsEnabled || (transcriptionsOn == undefined || !transcriptionsOn)" (selectionChange)="updateTranscriptionLang()">
              <mat-option [value]="undefined"> ----- </mat-option>
              @for (lang of transcriptionLangs; track lang) {
                <mat-option [value]="lang[0]">{{lang[1]}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  }
</div>
</div>
